import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import pathsManifest from 'app/shared/utils/pathsManifest';
import { TabGroup, TabItem, TabRow } from './styles';

const UserSettingsTabs = () => {
  const location = useLocation();
  const { pathname } = location;

  const handleProfileClick = useCallback(() => {
    if (pathname !== pathsManifest.UserEditPage) {
      window.router.transitionTo(pathsManifest.UserEditPage);
    }
  }, [pathname]);

  const handleNotificationsClick = useCallback(() => {
    if (pathname !== pathsManifest.UserSettingsPage) {
      window.router.transitionTo(pathsManifest.UserSettingsPage);
    }
  }, [pathname]);

  const handleRenterProfileClick = useCallback(() => {
    if (pathname !== pathsManifest.UserRenterProfilePage) {
      window.router.transitionTo(pathsManifest.UserRenterProfilePage);
    }
  }, [pathname]);

  return (
    <TabRow>
      <TabGroup maxWidth>
        <TabItem active={pathname === pathsManifest.UserEditPage} onClick={handleProfileClick}>
          Profile
        </TabItem>
        <TabItem active={pathname === pathsManifest.UserRenterProfilePage} onClick={handleRenterProfileClick}>
          Renter Resume
        </TabItem>
        <TabItem active={pathname === pathsManifest.UserSettingsPage} onClick={handleNotificationsClick}>
          Notifications
        </TabItem>
      </TabGroup>
    </TabRow>
  );
};

export default UserSettingsTabs;
